export default __webpack_public_path__ + "static/media/mint.54f7febc.png";